// App start

window.App = {}

App.components = {}

App.currentPageIs = (controller, action) =>
  document.body.classList.contains(controller) && document.body.classList.contains(action)

// Any form with the data attribute turboform is submited using a GET method
// and Turbo.
//
$(document).on("submit", "form[data-turboform]", function (e) {
  Turbo.visit(this.action + (this.action.indexOf("?") === -1 ? "?" : "&") + $(this).serialize())
  return false
})

// Any form with the data attribute turboform-keeps-previous-query is submited
// using a GET method and Turbo. But in addition, it will keep all existing
// query params in the URL. This is especially useful if most of the
// configuration is in the URL and then handled and saved on the server side.
//
$(document).on("submit", "form[data-turboform-keeps-previous-query]", function (e) {
  let params
  if (location.search.length > 0) {
    params = JSON.parse(
      '{"' +
        decodeURI(location.search.substring(1))
          .replace(/"/g, '\"')
          .replace(/&/g, '","')
          .replace(RegExp("=", "g"), '":"') +
        '"}',
    )
  } else {
    params = {}
  }

  // Once we have extracted the current parameters, we iterate over the new query
  // params and add them.

  const newParams = JSON.parse(
    '{"' +
      decodeURI($(this).serialize()).replace(/"/g, '\"').replace(/&/g, '","').replace(RegExp("=", "g"), '":"') +
      '"}',
  )

  for (const [key, value] of Object.entries(newParams)) {
    params[key] = value
  }

  Turbo.visit(this.action + (this.action.indexOf("?") === -1 ? "?" : "&") + $.param(params))
  return false
})

// App end

// Utilities start

// Returns the hostname from the provided input, if it's a valid URL or domain name.
// If it doesn't look like so, the input is returned right away.
// TODO: instead of returning the provided input, an empty string should be returned
// and the caller should act accordingly.
App.hostnameFromURL = function (input) {
  input = input.toLowerCase().trim()

  // Remove any heading "@"
  input = input.replace(/^@/, "")

  // The input isn't a domain name nor a URL, we return right away
  if (input.indexOf(" ") !== -1 || input.indexOf("@") !== -1) {
    return input
  }

  let url

  try {
    url = new URL(input)
  } catch (_) {
    // Not an URL - create a fake one so we can extract the hostname
    url = document.createElement("a")
    url.href = `http://${input}`
  }

  // Remove "www." from the hostname and return it
  return url.hostname.replace(/^(www\.)/, "")
}

App.isADomainName = function (input) {
  var re = new RegExp(
    /^(((?!\-))(xn\-\-)?[a-z0-9\-_]{0,61}[a-z0-9]{1,1}\.)*(xn\-\-)?([a-z0-9\-]{1,61}|[a-z0-9\-]{1,30})\.[a-z]{2,}$/,
  )
  return input.match(re)
}

App.stripTrailingSlash = function (str) {
  if (str.substr(-1) === "/") {
    return str.substr(0, str.length - 1)
  }
  return str
}

App.numberWithCommas = function (x) {
  if (x % 1 !== 0) {
    x = parseFloat(x).toFixed(2)
  }

  x = x.toString()
  const pattern = /(-?\d+)(\d{3})/
  while (pattern.test(x)) {
    x = x.replace(pattern, "$1,$2")
  }
  return x
}

App.validateEmail = function (email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

// "Blind" interval clearing, not the cleanest way but still efficient
App.clearAllIntervals = () => [1, 99999].map((i) => window.clearInterval(i))

App.createCookie = function (name, value, days) {
  let expires
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = "; expires=" + date.toGMTString()
  } else {
    expires = ""
  }

  let secure = window.rails_env === "production" ? "; secure" : ""

  document.cookie = name + "=" + value + expires + secure + "; path=/"
}

App.readCookie = function (name) {
  const nameEQ = name + "="
  const ca = document.cookie.split(";")
  let i = 0
  while (i < ca.length) {
    let c = ca[i]
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length)
    }
    i++
  }
  return null
}

App.eraseCookie = function (name) {
  App.createCookie(name, "", -1)
}

App.executeCopy = function (text, id = null) {
  const input = document.createElement("textarea")

  let selector

  // For some reasons, it is necessary to create a new block in the
  // page to make sure it's considered accessible by the brower, and
  // make sure the copy from input works.
  // For example, when a modal is open. In other cases, the default
  // block #copy-area is used.
  if (id) {
    selector = $(`#${id}`)
  } else {
    selector = $("#copy-area")
  }

  selector.prepend(input)
  input.value = text
  input.focus()
  input.select()
  document.execCommand("Copy")
  input.remove()
}

App.userDate = function (date, withTheYear) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  const d = new Date(Date.parse(date))
  const monthIndex = d.getMonth()
  const year = d.getFullYear()
  const day = d.getDate()

  if (withTheYear) {
    return monthNames[monthIndex] + " " + day + ", " + year
  } else {
    return monthNames[monthIndex] + " " + day
  }
}

App.trimChars = function (string, length) {
  if (string.length > length) {
    return string.substring(0, length).trim() + "..."
  } else {
    return string
  }
}

App.removeDuplicateValues = function (array) {
  const unique = []
  $.each(array, function (i, el) {
    if ($.inArray(el, unique) === -1) {
      unique.push(el)
    }
  })
  return unique
}

App.openInNewTab = function (url) {
  const win = window.open(url, "_blank")
  win.focus()
}

App.addUrlParam = function (search, key, val) {
  const newParam = key + "=" + val
  let params = "?" + newParam
  if (search) {
    params = search.replace(new RegExp("([?&])" + key + "[^&]*"), "$1" + newParam)
    if (params === search) {
      params += "&" + newParam
    }
  }
  return params
}

App.removeUrlParam = function (key, sourceURL) {
  let rtn = sourceURL.split("?")[0]
  let param = undefined
  let params_arr = []
  const queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : ""
  if (queryString !== "") {
    params_arr = queryString.split("&")
    let i = params_arr.length - 1
    while (i >= 0) {
      param = params_arr[i].split("=")[0]
      if (param === key) {
        params_arr.splice(i, 1)
      }
      i -= 1
    }
    rtn = rtn + "?" + params_arr.join("&")
  }
  return rtn
}

App.findGetParameter = function (parameterName) {
  let result = null
  let tmp = []
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=")
      if (tmp[0] === parameterName) {
        result = decodeURIComponent(tmp[1])
      }
    })
  return result
}

App.capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1)

// Capitalizes the first letter of each word in the string and lower cases
// the other letters
//
App.toTitleCase = (string) =>
  string
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(" ")

App.imageExists = function (url, callback) {
  const img = new Image()

  img.onload = function () {
    callback(true)
  }

  img.onerror = function () {
    callback(false)
  }

  img.src = url
}

// Source: https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
// Updated it on the 19/12/2018 as the previous version, using
// window.chrome.webstore, wasn't working anymore.
//
App.browserIsChrome = (function () {
  const isChromium = window.chrome
  const winNav = window.navigator
  const vendorName = winNav.vendor
  const isOpera = typeof window.opr !== "undefined"
  const isIEedge = winNav.userAgent.indexOf("Edge") > -1
  const isIOSChrome = winNav.userAgent.match("CriOS")

  return (
    isIOSChrome ||
    (isChromium !== null &&
      typeof isChromium !== "undefined" &&
      vendorName === "Google Inc." &&
      isOpera === false &&
      isIEedge === false)
  )
})()

App.browserIsFirefox = (() => typeof InstallTrigger !== "undefined")()

App.browserIsSafari = (() =>
  /constructor/i.test(window.HTMLElement) ||
  ((p) => p.toString() === "[object SafariRemoteNotification]")(!window["safari"] || safari.pushNotification))()

App.isTabVisible = (function () {
  let stateKey = undefined
  let eventKey = undefined
  const keys = {
    hidden: "visibilitychange",
    webkitHidden: "webkitvisibilitychange",
    mozHidden: "mozvisibilitychange",
    msHidden: "msvisibilitychange",
  }
  for (stateKey in keys) {
    stateKey = stateKey
    if (stateKey in document) {
      eventKey = keys[stateKey]
      break
    }
  }
  return function (c) {
    if (c) {
      document.addEventListener(eventKey, c)
    }
    return !document[stateKey]
  }
})()

// This method is useful to prevent multiple clicks on the OAuth links,
// that are causing issues with Google (CSRF errors). Instead, we create a
// button and call this function to listen clicks on this button. The function
// disables it at the first click, and then POSTs a form to the provided
// destination.
//
App.oauthConnect = (buttonSelector, destination) =>
  $(buttonSelector).on("click", function (event) {
    $(this).prop("disabled", true)

    if (typeof $(this).data("loading") !== "undefined") {
      $(this).html(`<div class='far fa-spinner-third fa-spin'></div> ${_this.first().data("loading")}`)
    } else {
      $(this).html(`<div class='far fa-spinner-third fa-spin'></div> ${i18n.t("js.loading")}`)
    }

    const oauthForm = document.createElement("form")
    oauthForm.method = "POST"
    oauthForm.action = destination

    const csrfTokenInput = document.createElement("input")
    csrfTokenInput.type = "hidden"
    csrfTokenInput.value = $("meta[name='csrf-token']").attr("content")
    csrfTokenInput.name = "authenticity_token"
    oauthForm.appendChild(csrfTokenInput)

    if (event.target.dataset.returnTo) {
      const originInput = document.createElement("input")
      originInput.type = "hidden"
      originInput.value = event.target.dataset.returnTo
      originInput.name = "origin"
      oauthForm.appendChild(originInput)
    }

    document.body.appendChild(oauthForm)

    return oauthForm.submit()
  })

// This method attaches a tooltip to the passed DOM element and safely
// destroys it. If the passed element already has a visible tooltip
// attached, we do nothing.
//
App.showDismissableTooltip = function (selector, title, duration) {
  // prevents building and finally destroying a new tooltip
  // whereas one is already attached to the selector
  if (selector.next("div.tooltip:visible").length) {
    return
  }

  selector.tooltip({ title }).tooltip("show")

  return setTimeout(() => selector.tooltip("destroy"), duration)
}

// Standard way to copy email addresses in the tools
//
App.copyEmailListener = function () {
  $(".email").mouseover(function () {
    return $(this).parent().find(".copy-status").fadeIn(200)
  })
  $(".email").mouseout(function () {
    return $(this).parent().find(".copy-status").fadeOut(200)
  })
  return $(".email").on("click", function () {
    const email = $(this).text()
    App.executeCopy(email)
    const email_copied = $(this).parent().find(".email-copied")
    email_copied.text(email)
    email_copied.css({
      opacity: 0.5,
    })
    email_copied.animate(
      {
        opacity: 0,
        top: "-18px",
      },
      300,
      function () {
        email_copied.removeAttr("style")
        return email_copied.text("")
      },
    )

    const copy_status = $(this).parent().find(".copy-status")
    copy_status.show().text(i18n.t("js.copied"))
    return copy_status.delay(400).fadeOut(200, () => copy_status.text(i18n.t("js.copy")))
  })
}

// Sort an object by values
//
App.sortObject = function (array) {
  const sortable = []
  for (let el in array) {
    sortable.push([el, array[el]])
  }
  sortable.sort((a, b) => b[1] - a[1])

  return sortable
}

// This function creates an MD5 of a String
//
App.MD5 = function (s) {
  let C = Array()
  let P = undefined
  let h = undefined
  let E = undefined
  let v = undefined
  let g = undefined
  let Y = undefined
  let X = undefined
  let W = undefined
  let V = undefined
  const S = 7
  const Q = 12
  const N = 17
  const M = 22
  const A = 5
  const z = 9
  const y = 14
  const w = 20
  const o = 4
  const m = 11
  const l = 16
  const j = 23
  const U = 6
  const T = 10
  const R = 15
  const O = 21

  const L = (k, d) => (k << d) | (k >>> (32 - d))

  const K = function (G, k) {
    let I = undefined
    let d = undefined
    let F = undefined
    let H = undefined
    let x = undefined
    F = G & 2147483648
    H = k & 2147483648
    I = G & 1073741824
    d = k & 1073741824
    x = (G & 1073741823) + (k & 1073741823)
    if (I & d) {
      return x ^ 2147483648 ^ F ^ H
    }
    if (I | d) {
      if (x & 1073741824) {
        return x ^ 3221225472 ^ F ^ H
      } else {
        return x ^ 1073741824 ^ F ^ H
      }
    } else {
      return x ^ F ^ H
    }
  }

  const r = (d, F, k) => (d & F) | (~d & k)

  const q = (d, F, k) => (d & k) | (F & ~k)

  const p = (d, F, k) => d ^ F ^ k

  const n = (d, F, k) => F ^ (d | ~k)

  const u = function (G, F, aa, Z, k, H, I) {
    G = K(G, K(K(r(F, aa, Z), k), I))
    return K(L(G, H), F)
  }

  const f = function (G, F, aa, Z, k, H, I) {
    G = K(G, K(K(q(F, aa, Z), k), I))
    return K(L(G, H), F)
  }

  const D = function (G, F, aa, Z, k, H, I) {
    G = K(G, K(K(p(F, aa, Z), k), I))
    return K(L(G, H), F)
  }

  const t = function (G, F, aa, Z, k, H, I) {
    G = K(G, K(K(n(F, aa, Z), k), I))
    return K(L(G, H), F)
  }

  const e = function (G) {
    let Z = undefined
    const F = G.length
    const x = F + 8
    const k = (x - (x % 64)) / 64
    const I = (k + 1) * 16
    const aa = Array(I - 1)
    let d = 0
    let H = 0
    while (H < F) {
      Z = (H - (H % 4)) / 4
      d = (H % 4) * 8
      aa[Z] = aa[Z] | (G.charCodeAt(H) << d)
      H++
    }
    Z = (H - (H % 4)) / 4
    d = (H % 4) * 8
    aa[Z] = aa[Z] | (128 << d)
    aa[I - 2] = F << 3
    aa[I - 1] = F >>> 29
    return aa
  }

  const B = function (x) {
    let k = ""
    let F = ""
    let G = undefined
    let d = undefined
    d = 0
    while (d <= 3) {
      G = (x >>> (d * 8)) & 255
      F = "0" + G.toString(16)
      k = k + F.substr(F.length - 2, 2)
      d++
    }
    return k
  }

  const J = function (k) {
    k = k.replace(/rn/g, "n")
    let d = ""
    let F = 0
    while (F < k.length) {
      const x = k.charCodeAt(F)
      if (x < 128) {
        d += String.fromCharCode(x)
      } else {
        if (x > 127 && x < 2048) {
          d += String.fromCharCode((x >> 6) | 192)
          d += String.fromCharCode((x & 63) | 128)
        } else {
          d += String.fromCharCode((x >> 12) | 224)
          d += String.fromCharCode(((x >> 6) & 63) | 128)
          d += String.fromCharCode((x & 63) | 128)
        }
      }
      F++
    }
    return d
  }

  s = J(s)
  C = e(s)
  Y = 1732584193
  X = 4023233417
  W = 2562383102
  V = 271733878
  P = 0
  while (P < C.length) {
    h = Y
    E = X
    v = W
    g = V
    Y = u(Y, X, W, V, C[P + 0], S, 3614090360)
    V = u(V, Y, X, W, C[P + 1], Q, 3905402710)
    W = u(W, V, Y, X, C[P + 2], N, 606105819)
    X = u(X, W, V, Y, C[P + 3], M, 3250441966)
    Y = u(Y, X, W, V, C[P + 4], S, 4118548399)
    V = u(V, Y, X, W, C[P + 5], Q, 1200080426)
    W = u(W, V, Y, X, C[P + 6], N, 2821735955)
    X = u(X, W, V, Y, C[P + 7], M, 4249261313)
    Y = u(Y, X, W, V, C[P + 8], S, 1770035416)
    V = u(V, Y, X, W, C[P + 9], Q, 2336552879)
    W = u(W, V, Y, X, C[P + 10], N, 4294925233)
    X = u(X, W, V, Y, C[P + 11], M, 2304563134)
    Y = u(Y, X, W, V, C[P + 12], S, 1804603682)
    V = u(V, Y, X, W, C[P + 13], Q, 4254626195)
    W = u(W, V, Y, X, C[P + 14], N, 2792965006)
    X = u(X, W, V, Y, C[P + 15], M, 1236535329)
    Y = f(Y, X, W, V, C[P + 1], A, 4129170786)
    V = f(V, Y, X, W, C[P + 6], z, 3225465664)
    W = f(W, V, Y, X, C[P + 11], y, 643717713)
    X = f(X, W, V, Y, C[P + 0], w, 3921069994)
    Y = f(Y, X, W, V, C[P + 5], A, 3593408605)
    V = f(V, Y, X, W, C[P + 10], z, 38016083)
    W = f(W, V, Y, X, C[P + 15], y, 3634488961)
    X = f(X, W, V, Y, C[P + 4], w, 3889429448)
    Y = f(Y, X, W, V, C[P + 9], A, 568446438)
    V = f(V, Y, X, W, C[P + 14], z, 3275163606)
    W = f(W, V, Y, X, C[P + 3], y, 4107603335)
    X = f(X, W, V, Y, C[P + 8], w, 1163531501)
    Y = f(Y, X, W, V, C[P + 13], A, 2850285829)
    V = f(V, Y, X, W, C[P + 2], z, 4243563512)
    W = f(W, V, Y, X, C[P + 7], y, 1735328473)
    X = f(X, W, V, Y, C[P + 12], w, 2368359562)
    Y = D(Y, X, W, V, C[P + 5], o, 4294588738)
    V = D(V, Y, X, W, C[P + 8], m, 2272392833)
    W = D(W, V, Y, X, C[P + 11], l, 1839030562)
    X = D(X, W, V, Y, C[P + 14], j, 4259657740)
    Y = D(Y, X, W, V, C[P + 1], o, 2763975236)
    V = D(V, Y, X, W, C[P + 4], m, 1272893353)
    W = D(W, V, Y, X, C[P + 7], l, 4139469664)
    X = D(X, W, V, Y, C[P + 10], j, 3200236656)
    Y = D(Y, X, W, V, C[P + 13], o, 681279174)
    V = D(V, Y, X, W, C[P + 0], m, 3936430074)
    W = D(W, V, Y, X, C[P + 3], l, 3572445317)
    X = D(X, W, V, Y, C[P + 6], j, 76029189)
    Y = D(Y, X, W, V, C[P + 9], o, 3654602809)
    V = D(V, Y, X, W, C[P + 12], m, 3873151461)
    W = D(W, V, Y, X, C[P + 15], l, 530742520)
    X = D(X, W, V, Y, C[P + 2], j, 3299628645)
    Y = t(Y, X, W, V, C[P + 0], U, 4096336452)
    V = t(V, Y, X, W, C[P + 7], T, 1126891415)
    W = t(W, V, Y, X, C[P + 14], R, 2878612391)
    X = t(X, W, V, Y, C[P + 5], O, 4237533241)
    Y = t(Y, X, W, V, C[P + 12], U, 1700485571)
    V = t(V, Y, X, W, C[P + 3], T, 2399980690)
    W = t(W, V, Y, X, C[P + 10], R, 4293915773)
    X = t(X, W, V, Y, C[P + 1], O, 2240044497)
    Y = t(Y, X, W, V, C[P + 8], U, 1873313359)
    V = t(V, Y, X, W, C[P + 15], T, 4264355552)
    W = t(W, V, Y, X, C[P + 6], R, 2734768916)
    X = t(X, W, V, Y, C[P + 13], O, 1309151649)
    Y = t(Y, X, W, V, C[P + 4], U, 4149444226)
    V = t(V, Y, X, W, C[P + 11], T, 3174756917)
    W = t(W, V, Y, X, C[P + 2], R, 718787259)
    X = t(X, W, V, Y, C[P + 9], O, 3951481745)
    Y = K(Y, h)
    X = K(X, E)
    W = K(W, v)
    V = K(V, g)
    P += 16
  }
  const i = B(Y) + B(X) + B(W) + B(V)
  return i.toLowerCase()
}

// This function waits for a script to be loaded before launching the code.
// This is especially important because of the way Turbo work.
App.whenAvailable = function (name, callback) {
  const interval = 30 // ms
  window.setTimeout(function () {
    if (window[name]) {
      callback(window[name])
    } else {
      window.setTimeout(App.whenAvailable(name, callback), interval)
    }
  }, interval)
}

// Temporary: These functions are only useful while we migrate all our JS to importmaps.
App.popover = function (target, options) {
  $(target).popover(options)
}

App.tooltip = function (target, options) {
  $(target).tooltip(options)
}

App.modal = function (target, options) {
  $(target).modal(options)
}

App.modalEvent = function (target, event, callback) {
  $(target).on(event, callback)
}

// Utilities end

// Analytics start

const Analytics = function () {
  // Custom tracking
  //
  this.track = function (name, properties, callback) {
    $.ajax({
      url: "/events",
      data: {
        name,
        properties,
      },
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      type: "POST",
      dataType: "json",
      success(data) {
        if (window.rails_env === "development") {
          console.info(`Event tracked: ${name}`)
        }

        return callback && callback()
      },
    })
  }

  // Google Analytics event tracking
  //
  this.ga_track = (category, action) =>
    App.whenAvailable("gtag", function () {
      if (window.rails_env !== "test") {
        gtag("event", action, { event_category: category })

        if (window.rails_env === "development") {
          return console.info(`GUA tracked: action \"${action}\" in category \"${category}\"`)
        }
      }
    })

  this.ga4_track = (name) => {
    if (window.rails_env !== "test" && typeof dataLayer !== "undefined") {
      dataLayer.push({ event: name })
    }
  }

  this.posthog_capture = (name, options = {}) => {
    if (window.rails_env !== "test" && typeof posthog !== "undefined") {
      posthog.capture(name, options)
    }
  }

  // Google Analytics pageview tracking
  //
  this.trackPageview = () =>
    App.whenAvailable("gtag", function () {
      if (typeof gon !== "undefined" && window.rails_env !== "test") {
        gtag("config", gon.google_analytics_id, { page_location: window.location.href })
      }
    })

  // Google Analytics user ID tracking
  //
  this.ga_set_user = (user_id) =>
    App.whenAvailable("gtag", function () {
      if (typeof gon !== "undefined" && window.rails_env !== "test") {
        gtag("config", gon.google_analytics_id, { user_id: user_id })
      }
    })

  // Google Analytics send page view
  this.sendPageview = (title, location, path) =>
    App.whenAvailable("gtag", function () {
      if (window.rails_env !== "test") {
        gtag("event", "page_view", {
          page_title: title,
          page_location: location,
          page_path: path,
          send_to: gon.google_analytics_id,
        })
      }
    })
}

App.analytics = new Analytics()

document.addEventListener("turbo:load", function () {
  // At each pageload with track the pageview
  App.analytics.trackPageview()

  // Tracking of the signup
  if (App.currentPageIs("user_intent", "new")) {
    App.analytics.ga_track("Account", "Sign up")
  }

  // Tracking of the signin
  const signin_page = window.location.protocol + "//" + window.location.host + "/users/sign_in"
  if (document.referrer === signin_page && App.currentPageIs("search", "index")) {
    App.analytics.ga_track("Account", "Sign in")
  }

  // We send Google Analytics the user ID (if available)
  // It allows to track the same people accross devices.
  // https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id

  // Check if gon is defined before accessing user properties
  if (typeof gon !== "undefined" && gon.user && gon.user.id) {
    return App.analytics.ga_set_user(gon.user.id)
  }
})

// Analytics end

// API start

const API_VERSION = "v2"

App.api = {}

App.api.domainSearch = function ({
  domain,
  limit,
  offset,
  type,
  department,
  requiredField,
  jobTitles,
  verificationStatus,
  format,
  source,
  savedLeads,
}) {
  limit = limit || 10

  if (type !== null && typeof type !== "undefined") {
    type = "&type=" + type
  } else {
    type = ""
  }

  if (department !== null && typeof department !== "undefined") {
    department = "&department=" + department
  } else {
    department = ""
  }

  if (requiredField !== null && typeof requiredField !== "undefined") {
    requiredField = "&required_field=" + requiredField
  } else {
    requiredField = ""
  }

  if (jobTitles !== null && typeof jobTitles !== "undefined") {
    jobTitles = "&job_titles=" + jobTitles
  } else {
    jobTitles = ""
  }

  if (verificationStatus !== null && typeof verificationStatus !== "undefined") {
    verificationStatus = "&verification_status=" + verificationStatus
  } else {
    verificationStatus = ""
  }

  if (savedLeads !== null && typeof savedLeads !== "undefined") {
    savedLeads = "&saved_leads=" + savedLeads
  } else {
    savedLeads = ""
  }

  if (offset !== null && typeof offset !== "undefined" && offset !== 0) {
    offset = "&offset=" + offset
  } else {
    offset = ""
  }

  const auth = "&api_key=" + gon.api_key

  let url = `/${API_VERSION}/domain-search`

  if (format !== null && typeof format !== "undefined") {
    url += `.${format}`
  }

  url +=
    `/?source=${source}&limit=${limit}` +
    offset +
    "&domain=" +
    domain +
    type +
    department +
    requiredField +
    jobTitles +
    verificationStatus +
    savedLeads +
    auth

  return url
}

App.api.trialDomainSearch = (domain, token) =>
  `/trial/${API_VERSION}/domain-search?limit=10&offset=0&domain=${domain}&token=${token}`

App.api.emailCount = function (domain, type) {
  const auth = "&api_key=" + gon.api_key

  if (type !== null && typeof type !== "undefined") {
    type = "&type=" + type
  } else {
    type = ""
  }

  return `/${API_VERSION}/email-count?domain=` + encodeURIComponent(domain) + type + auth
}

App.api.verifyEmail = function (email, format = "json", version = "", includeDomainMetadata = false) {
  const auth = "&api_key=" + gon.api_key

  let url = `/${API_VERSION}/email-verifier`

  if (format !== null && typeof format !== "undefined") {
    url += `.${format}`
  }

  url += "?email=" + encodeURIComponent(email) + "&version=" + version + auth

  if (includeDomainMetadata) {
    url += "&domain_metadata=1"
  }

  return url
}

App.api.trialVerifyEmail = (email, token) =>
  `/trial/${API_VERSION}/email-verifier?email=` + encodeURIComponent(email) + "&token=" + token

App.api.findEmail = function (domain, full_name, format, version = "") {
  const auth = "&api_key=" + gon.api_key

  let url = `/${API_VERSION}/email-finder`

  if (format !== null && typeof format !== "undefined") {
    url += `.${format}`
  }

  url += `/?domain=` + domain + "&full_name=" + full_name + "&version=" + version + auth

  return url
}

App.api.trialFindEmail = (domain, full_name, token) =>
  `/trial/${API_VERSION}/email-finder?domain=` + domain + "&full_name=" + full_name + "&token=" + token

App.api.emailInsight = (email) => `/${API_VERSION}/email-insight?email=` + email

App.api.leadExist = function (email) {
  const auth = "&api_key=" + gon.api_key
  return `/${API_VERSION}/leads/exist?email=` + email + auth
}

App.api.leadsExist = function (emails) {
  const auth = "&api_key=" + gon.api_key

  let emailsParam = ""
  emails.forEach((email) => {
    emailsParam += `&emails[]=${email}`
  })

  return `/${API_VERSION}/leads/bulk/exist?` + emailsParam + auth
}

App.api.leads = function (leads_list_id, limit) {
  const auth = "&api_key=" + gon.api_key
  let leads_list_param = ""
  if (leads_list_id != null) {
    leads_list_param = "leads_list_id=" + leads_list_id + "&"
  }

  return `/${API_VERSION}/leads?` + leads_list_param + "limit=" + limit + auth
}

App.api.leadsList = function (limit) {
  const auth = "&api_key=" + gon.api_key

  return `/${API_VERSION}/leads_lists?limit=${limit}${auth}`
}

App.api.leadDelete = function (lead_id) {
  const auth = "?api_key=" + gon.api_key
  return `/${API_VERSION}/leads/${lead_id}${auth}`
}

App.api.leadCreate = function () {
  const auth = "?api_key=" + gon.api_key
  return `/${API_VERSION}/leads` + auth
}

App.api.createLeadList = function () {
  const auth = "?api_key=" + gon.api_key
  return `/${API_VERSION}/leads_lists${auth}`
}

App.api.userAccount = () => `/${API_VERSION}/account?api_key=${gon.api_key}`

App.api.domainsSuggestion = function (query) {
  return `/${API_VERSION}/domains-suggestion?query=${encodeURIComponent(query)}`
}

App.api.addToCampaign = function (campaign_id) {
  return `/${API_VERSION}/campaigns/${campaign_id}/recipients?api_key=${gon.api_key}`
}

App.api.getUnarchivedCampaigns = function (limit) {
  const auth = "&api_key=" + gon.api_key

  return `/${API_VERSION}/campaigns?limit=${limit}&archived=false${auth}`
}

// API end

// Bootstrap start

//
// Popover
//
bootstrap.Popover.Default.html = true

document.addEventListener("turbo:load", function () {
  $('[data-bs-toggle="popover"]').popover()
})

document.addEventListener("turbo:load", () =>
  $("body").on("click", (e) =>
    $('[data-bs-toggle="popover"], [data-controller="popover"]').each(function () {
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $(".popover").has(e.target).length === 0) {
        return $(this).popover("hide")
      }
    }),
  ),
)

//
// Tooltip
//
bootstrap.Tooltip.Default.allowList["*"].push(/^data-turbo-?[\w-]*$/i)

document.addEventListener("turbo:load", function () {
  $('[data-bs-toggle="tooltip"]').tooltip()
})

//
// Autofocus in modal
//
$(".modal").on("shown.bs.modal", function () {
  $(this).find("[autofocus]").focus()
})

// Bootstrap end

// Flash start

App.displayFlash = function (type, message, status, messageDuration) {
  let icon
  if (status == null) {
    status = ""
  }
  App.hideFlash()

  if (status !== "") {
    if (status === 0) {
      message += " (CORS issue)"
    } else {
      message += ` (status: ${status})`
    }
  }

  if (type === "success") {
    icon = "<i class='far fa-check'></i>"
  } else if (type === "danger") {
    icon = "<i class='far fa-circle-xmark'></i>"
  } else if (type === "pending") {
    icon = "<i class='far fa-spinner-third fa-spin'></i>"
  } else {
    icon = "<i class='far fa-exclamation-triangle'></i>"
  }

  $("#flash").html(`<div class="alert" role="alert">${icon} <div class="flash__content">${message}</div></div>`)
  $("#flash").fadeIn(200)

  if (!messageDuration) {
    // Do not overwrite a given messageDuration
    if (gon.environment === "test") {
      messageDuration = 70000
    } else if (type === "success") {
      messageDuration = 10000
    } else {
      messageDuration = 15000
    }
  }

  return setTimeout(() => $("#flash").fadeOut(200), messageDuration)
}

App.hideFlash = function () {
  $("#flash").html("")
  return $("#flash").hide()
}

//
// Show error on dashboard
//

window.showErrorDashboard = function (html) {
  $(".dashboard-search-error").html(html)
  return $("#domain-field").removeClass("loading")
}

// Fade out flash alerts generated on the backend side after a while
//
document.addEventListener("turbo:load", () =>
  $("#flash .alert").each(function () {
    const flashMessage = $(this)

    if (flashMessage.hasClass("alert-dismissible") === false) {
      return false
    }

    let flashDuration = 10000

    if (flashMessage.hasClass("alert-success")) {
      flashDuration = 15000
    }

    return setTimeout(() => flashMessage.fadeOut(200), flashDuration)
  }),
)

// Flash end

// From start

//
// Disable the form buttons on click
//
App.initializeRadios = function () {
  $(".radios-container input[type=radio]").on("change", function () {
    const radiosIcon = $(this).closest(".radios-container").find(".radio-icon")
    const radioIcon = $(this).closest(".radio-container").find(".radio-icon")
    const radio = $(this).closest(".radio-container").find("input[type=radio]")

    radiosIcon.removeClass("fa-check-circle").addClass("fa-circle")

    if (radio.is(":checked")) {
      return radioIcon.removeClass("fa-circle").addClass("fa-check-circle")
    } else {
      return radioIcon.removeClass("fa-check-circle").addClass("fa-circle")
    }
  })
}

let initializeForm = function () {
  App.initializeRadios()

  $("form").on("submit", function () {
    const _this = $(this).find("button[type='submit'], input[type='submit']")

    // Save the text of the button before submit
    _this.data("text", _this.first().text())

    if (_this.data("loading") === "none") {
      return
    }

    _this.prop("disabled", true)

    if (typeof _this.data("loading") !== "undefined") {
      _this.first().html(`<div class='far fa-spinner-third fa-spin'></div> ${_this.first().data("loading")}`)
      return _this.first().attr("value", _this.first().data("loading"))
    } else {
      _this.first().html(`<div class='far fa-spinner-third fa-spin'></div> ${i18n.t("js.loading")}`)
      return _this.first().attr("value", i18n.t("js.loading"))
    }
  })

  $(".main-input-group input, .input-group input").focus(function () {
    return $(this).parent().addClass("focus")
  })

  $(".main-input-group input, .input-group input").blur(function () {
    return $(this).parent().removeClass("focus")
  })

  $(".checkbox-container input[type=checkbox]").on("change", function () {
    const checkboxIcon = $(this).closest(".checkbox-container").find(".checkbox-icon")
    const checkbox = $(this).closest(".checkbox-container").find("input[type=checkbox]")

    if (checkbox.is(":checked")) {
      return checkboxIcon.removeClass("fa-square").addClass("fa-check-square")
    } else {
      return checkboxIcon.removeClass("fa-check-square").addClass("fa-square")
    }
  })

  $(".block-checkbox-container input[type=checkbox]").on("change", function () {
    return $(this).closest(".block-checkbox-container").toggleClass("active")
  })

  $(".block-radios-container input[type=radio]").on("change", function () {
    $(this).closest(".block-radios-container").find(".block-radio-container").removeClass("active")
    return $(this)
      .closest(".block-radios-container")
      .find("input[type=radio]:checked")
      .closest(".block-radio-container")
      .addClass("active")
  })

  return (App.enableForm = function () {
    $("button[type='submit'], input[type='submit']").each(function () {
      // Re-enable only the buttons that were disabled
      if ($(this).prop("disabled") === false) {
        return
      }

      $(this).prop("disabled", false)

      if (typeof $(this).data("text") !== "undefined") {
        return $(this).text($(this).data("text"))
      } else {
        return $(this).text(i18n.t("js.submit"))
      }
    })
  })
}

document.addEventListener("turbo:load", initializeForm)
document.addEventListener("turbo:frame-load", initializeForm)

// Form end

// Google Maps start

// Catch any error with Google Maps
// In this case, we prevent all the changes on the fields Gogole Maps does. The
// user mustn't notice any change and can enter the address manually.
//
window.gm_authFailure = function () {
  $("#address-field").attr("placeholder", "Enter your address...")
  $("#address-field").prop("disabled", false)
  $("#address-field").attr("style", "")
  return $("#address-field").focus()
}

// Google Maps end

// History start

// When a Domain Search, Email Finder of Email Verifier is launched, the history
// is changed with the given parameters. This function reloads the page when the
// "back" button of the browser is used to take into account the parameters
// previously entered.
//
window.addEventListener("popstate", function () {
  if (
    window.location.pathname.substring(0, 8) === "/search/" ||
    window.location.pathname.substring(0, 8) === "/verify/" ||
    window.location.pathname.substring(0, 6) === "/find/"
  ) {
    return Turbo.visit(window.location.href)
  }
})

// History end

// Intercom start

document.addEventListener("turbo:load", () => $(".open-intercom").click(() => Intercom("showNewMessage")))

// Intercom end

// Nav start

// Mobile navigation front
//
document.addEventListener("turbo:load", function () {
  $(".mobile-nav-btn").on("click", () => $(".mobile-nav").fadeIn(100))

  return $(".mobile-nav-close").on("click", () => $(".mobile-nav").fadeOut(100))
})

// Some elements can be in the cache of Turbo, but we don't want them to be
// displayed and just normally load after if they have to.
//
document.addEventListener("turbo:before-cache", function () {
  // Clean the front navigation
  $("#mobile-nav-overlay").remove()
  $(".mobile-nav").hide()

  // Clean the back account navigation
  $("#mobile-nav-overlay").remove()
  $("#mobile-nav-account-list").hide()
  return $("body").css({ overflow: "auto" })
})

// Nav end

// Notifications start

const hideButtonIfEnabled = () => $(".accept-notifications").hide()

document.addEventListener("turbo:load", function () {
  // Stop there for browsers that don't support notifications
  if (!("Notification" in window)) {
    return
  }

  $(".accept-notifications").show()

  if (Notification.permission !== "granted") {
    return $(".accept-notifications").on("click", () =>
      Notification.requestPermission(function (permission) {
        if (permission === "granted") {
          return hideButtonIfEnabled()
        }
      }),
    )
  } else if (Notification.permission === "granted") {
    return hideButtonIfEnabled()
  }
})

// Notifications end

// Smoothscroll start

document.addEventListener("turbo:load", () =>
  $('a[href^="#"]:not([data-bs-toggle]):not(.js-no-scroll)').click(function () {
    const the_id = $(this).attr("href")
    return $("html, body").animate({ scrollTop: $(the_id).offset().top }, "slow")
  }),
)

// Smoothscroll end

// Spinner start

App.spinner = {}

App.spinner.show = function () {
  const opts = {
    lines: 13,
    length: 28,
    width: 14,
    radius: 42,
    scale: 0.25,
    corners: 1,
    color: "#000",
    opacity: 0.25,
    rotate: 0,
    direction: 1,
    speed: 1,
    trail: 60,
    fps: 20,
    zIndex: 2e9,
    className: "spinner",
    top: "50%",
    left: "50%",
    shadow: false,
    hwaccel: false,
    position: "absolute",
  }
  const target = document.getElementById("spinner")
  const spinner = new Spinner(opts).spin(target)

  return $("#spinner").css("display", "block")
}

App.spinner.hide = () => $("#spinner").css("display", "none")

// Spinner end

// User start

// After the user gets a 429, checkUserAccount should be called to display
// the appropriate error message, based on the user available calls.
//
App.api.checkUserAccount = () =>
  $.ajax({
    url: App.api.userAccount(),
    headers: { "Email-Hunter-Origin": "website_dashboard" },
    type: "GET",
    data: { format: "json" },
    dataType: "json",
    error() {
      return App.displayFlash("danger", "Something went wrong on our side. Please try again later.")
    },
    success(result) {
      // The user account is hard frozen or blocked. They're redirected to the dashboard so the backoffice takes them to
      // the right validation/verification process.
      if (result.data.requests.searches.available === 0 && result.data.requests.verifications.available === 0) {
        Turbo.visit("/dashboard")
        return
      }

      // The user didn't reach their quota, no error message is displayed.
      // What brought us to run this function was just a temporary 429, most likely.
      if (
        result.data.requests.searches.used < result.data.requests.searches.available &&
        result.data.requests.verifications.used < result.data.requests.verifications.available
      ) {
        return
      }

      // The user account is soft frozen.
      if (result.data.requests.searches.available === 250 && result.data.requests.verifications.available === 250) {
        if (
          result.data.requests.searches.used >= result.data.requests.searches.available &&
          result.data.requests.verifications.used >= result.data.requests.verifications.available
        ) {
          App.displayFlash(
            "danger",
            "You have reached your temporary quota of searches and verifications. You will get your full access as soon as we validate your account.",
          )
        } else if (result.data.requests.searches.used >= result.data.requests.searches.available) {
          App.displayFlash(
            "danger",
            "You have reached your temporary quota of searches. You will get your full access as soon as we validate your account.",
          )
        } else if (result.data.requests.verifications.used >= result.data.requests.verifications.available) {
          App.displayFlash(
            "danger",
            "You have reached your temporary quota of verifications. You will get your full access as soon as we validate your account.",
          )
        }

        return
      }

      // The user is on a Free plan.
      if (result.data.plan_level === 0) {
        if (
          result.data.requests.searches.used >= result.data.requests.searches.available &&
          result.data.requests.verifications.used >= result.data.requests.verifications.available
        ) {
          App.displayFlash(
            "danger",
            "You have reached your free monthly quota. You can <a href='/subscriptions'>subscribe to a Premium plan</a> to make more requests.",
          )
        } else if (result.data.requests.searches.used >= result.data.requests.searches.available) {
          App.displayFlash(
            "danger",
            "You have reached your free monthly quota of searches. You can <a href='/subscriptions'>subscribe to a Premium plan</a> to make more requests.",
          )
        } else if (result.data.requests.verifications.used >= result.data.requests.verifications.available) {
          App.displayFlash(
            "danger",
            "You have reached your free monthly quota of verifications. You can <a href='/subscriptions'>subscribe to a Premium plan</a> to make more requests.",
          )
        }

        return
      }

      // User has enabled overage credits, no error message displayed.
      if (
        result.data.requests.searches.hasOwnProperty("over_quota") ||
        result.data.requests.verifications.hasOwnProperty("over_quota")
      ) {
        return
      }

      // The user is on a Premium plan without overage requests enabled.
      if (result.data.plan_level < 4) {
        if (
          result.data.requests.searches.used >= result.data.requests.searches.available &&
          result.data.requests.verifications.used >= result.data.requests.verifications.available
        ) {
          App.displayFlash(
            "danger",
            "You have reached your monthly quota. You can <a href='/welcome/upgrade'>upgrade to a higher plan</a> to make more requests.",
          )
        } else if (result.data.requests.searches.used >= result.data.requests.searches.available) {
          App.displayFlash(
            "danger",
            "You have reached your monthly quota of searches. You can <a href='/welcome/upgrade'>upgrade to a higher plan</a> to make more requests.",
          )
        } else if (result.data.requests.verifications.used >= result.data.requests.verifications.available) {
          App.displayFlash(
            "danger",
            "You have reached your monthly quota of verifications. You can <a href='/welcome/upgrade'>upgrade to a higher plan</a> to make more requests.",
          )
        }

        return
      }
    },
  })

// User end
